import React from 'react'

import { Loader } from '../../generic'

export const DefaultPageLoader = () => (
  <div className='main-loader qa-ml'>
    <div className='p-5 d-flex flex-row justify-content-center'>
      <Loader />
    </div>
  </div>
)

export default DefaultPageLoader
